// extracted by mini-css-extract-plugin
export default {"DimensionsFeature":"ws_a bik_b bik_we"};